export default "__VITE_ASSET__BQoVsYl5__"